import { render, staticRenderFns } from "./Investors.vue?vue&type=template&id=4b0ef1e0&"
import script from "./Investors.vue?vue&type=script&lang=js&"
export * from "./Investors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports